export const COPY = {
  parent: 'Back Office',
  title: 'Tax Reports',
  exportTaxReport: 'Download Note Report',
  exportIT3B: 'Download IT3B File',
  exportIT3C: 'Download IT3C File'
}
